import { Link, useNavigate, useLocation } from 'react-router-dom'
import React, { useState, useEffect } from 'react';
import axios from "axios";
// import '../../assets/css/animate.css';
// import '../../assets/css/lineicons.css';
// import '../../assets/css/main.css';
import { FaCheckCircle, FaSearch } from "react-icons/fa";
import { MdOutlineViewInAr } from "react-icons/md";
import { ImCool } from "react-icons/im";
import { FaFacebook } from "react-icons/fa";

import SearchField from './utils/SearchField';

const LandingPage = () => {

    const navigate = useNavigate()
    const location = useLocation();

    const [contactFormData, setContactFormData] = useState({
        email: '',
        message: ''
    });
    const [isContactLoading, setIsContactLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');


    useEffect(() => {
        if (location.hash === '#contact') {
            document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
        }
    }, [location]);


    const handleContactFormChange = (e) => {
        const { name, value } = e.target;
        setContactFormData({
            ...contactFormData,
            [name]: value
        });
    };

    const handleContactFormSubmit = async (e) => {
        e.preventDefault();
        setIsContactLoading(true);
        setSuccessMessage('');
        try {
            const response = await axios.post(process.env.REACT_APP_BACKEND_URL + '/api/v1/send-email', contactFormData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (response.status === 200) {
                setContactFormData({ email: '', message: '' });
                setSuccessMessage('Message was sent successfully!');
            } else {
                console.log('Error occurred while sending the email.')
                setSuccessMessage('Error occurred while sending the email, try it later :(');
            }
        } catch (error) {
            console.error('An error occurred:', error);
            setSuccessMessage('Error occurred while sending the email, try it later :(');

        } finally {
            setIsContactLoading(false);
        }
    };

    return (
        <>
            {/* Header */}
            <header className="header fixed-top">
                <div className="navbar-area sticky">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-12">
                                <nav className="navbar navbar-expand-lg">
                                    <a className="navbar-brand">
                                        <img src={`${process.env.PUBLIC_URL}/logo_trans.png`} alt="Logo" style={{ maxHeight: '50px', width: 'auto' }} /> 
                                        {process.env.REACT_APP_ENV === 'PROD' ? 'AR Board Games' : 'AR Board Games DEV'}
                                    </a>

                                    <div
                                        className="collapse navbar-collapse sub-menu-bar"
                                        id="navbarSupportedContent"
                                    >
                                        <ul id="nav" className="navbar-nav ms-auto">
                                            <li className="nav-item">
                                                <a className="page-scroll" href="#search">Search</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="page-scroll" href="#start">How to start</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="page-scroll" href="#about">About</a>
                                            </li>
                                            <li className="nav-item">
                                                <a href="#contact">Contact</a>
                                            </li>
                                        </ul>
                                    </div>

                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </header>


            {/* Hero Section */}
            <section id="search" className="hero-section">
                <div className="container">
                    <div className="row align-items-center position-relative">
                        <div className="col-lg-6">
                            <div className="hero-content">
                                <h1 className="wow fadeInUp" data-wow-delay=".4s">
                                    Bring Your Board Games to Life with AR Magic
                                </h1>
                                <p className="wow fadeInUp" data-wow-delay=".6s">
                                    Point your camera at the board game and enjoy the cool effects and visualizations
                                </p>
                                <SearchField />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="hero-video wow fadeInUp" data-wow-delay=".5s" style={{ display: 'flex', justifyContent: 'center' }}>
                                <video className="img-fluid" style={{ maxHeight: '500px', width: 'auto' }} controls autoPlay muted loop playsInline>
                                    <source src="https://storage4arvisualizerdev.blob.core.windows.net/public/videos/karak_hero.mp4" type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* How to start Section */}
            <section id="start" className="feature-section pt-120">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xxl-5 col-xl-6 col-lg-8 col-md-9">
                            <div className="section-title text-center mb-60">
                                <h2 className="mb-25 wow fadeInUp" data-wow-delay=".2s">
                                    How to start?
                                </h2>
                                <p className="wow fadeInUp" data-wow-delay=".4s">
                                    Follow these simple steps.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-4 col-md-8 col-sm-10">
                            <div className="single-feature">
                                <div className="icon">
                                    <FaSearch />
                                </div>
                                <div className="content">
                                    <h3>Search and select your board game</h3>
                                    <p>
                                        Check if we support your board game. Search for the board game's name in our search field.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-8 col-sm-10">
                            <div className="single-feature">
                                <div className="icon">
                                    <MdOutlineViewInAr />
                                </div>
                                <div className="content">
                                    <h3>Check triggering images</h3>
                                    <p>
                                        Check the images which trigger AR visualization of the selected board game.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-8 col-sm-10">
                            <div className="single-feature">
                                <div className="icon">
                                    <ImCool />
                                </div>
                                <div className="content">
                                    <h3>Enjoy cool visualization</h3>
                                    <p>
                                        Point your camera at the triggering images to start the cool AR visualization.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            {/* about Section */}
            <section id="about" className="feature-extended-section pt-100">
                <div className="feature-extended-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 d-flex align-items-center">
                                <div className="section-title">
                                    <h2 className="mb-25 wow fadeInUp" data-wow-delay=".2s">
                                        About us
                                    </h2>
                                    <p className="wow fadeInUp" data-wow-delay=".4s">
                                        We are a group of board game enthusiasts who love integrating technology into our games. By combining the magic of augmented reality with classic board games, we aim to reach a wider audience and bring more fun to everyone. We would love to hear your feedback and invite you to join us in building this community.
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-6 d-flex justify-content-center">
                                <div className="hero-video wow fadeInUp" data-wow-delay=".5s" style={{ display: 'flex', justifyContent: 'center' }}>
                                    <video className="img-fluid" style={{ maxHeight: '300px', width: 'auto' }} controls autoPlay muted loop playsInline>
                                        <source src="https://storage4arvisualizerdev.blob.core.windows.net/public/videos/karak_box.mp4" type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



            {/* Contact Section */}
            <section id="contact" className="subscribe-section pt-120">
                <div className="container">
                    <div className="subscribe-wrapper img-bg">
                        <div className="row align-items-center">
                            <div className="col-xl-6 col-lg-7">
                                <div className="section-title mb-15">
                                    <h2 className="text-white mb-25">Contact us</h2>
                                    <p className="text-white pr-5">
                                        Contact us if you have any questions or if you want to add your favorite game.
                                    </p>
                                </div>
                            </div>
                            <div className="col-xl-6 col-lg-5">
                                <form onSubmit={handleContactFormSubmit} className="contact-form">
                                    <input
                                        type="email"
                                        name="email"
                                        id="email"
                                        placeholder="Your Email"
                                        className="form-control mb-3"
                                        value={contactFormData.email}
                                        onChange={handleContactFormChange}
                                        required
                                    />
                                    <textarea
                                        name="message"
                                        id="message"
                                        placeholder="Message"
                                        className="form-control mb-3"
                                        rows="4"
                                        value={contactFormData.message}
                                        onChange={handleContactFormChange}
                                        required
                                    ></textarea>
                                    <div className="d-flex align-items-center">
                                        <button
                                            type="submit"
                                            className="main-btn border-btn btn-hover wow fadeInUp"
                                            data-wow-delay=".6s"
                                            style={{ borderColor: '#fff', color: '#fff' }}
                                            disabled={isContactLoading}
                                        >
                                            {isContactLoading ? 'Sending...' : 'Send'}
                                        </button>
                                        {successMessage && (
                                            <div className="ms-3 d-flex align-items-center" style={{ borderColor: '#fff', color: '#fff' }}>
                                                <FaCheckCircle size="30" className="me-2" /> {successMessage}
                                            </div>
                                        )}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>




            <footer className="footer" style={{ color: 'white' }}>
                <div className="container">
                    <div className="row text-center d-flex align-items-center">

                        {/* FB */}
                        <div className="col-12 col-sm-6">
                            <div className="footer-widget my-4">
                                <a
                                    href="https://www.facebook.com/profile.php?id=61574178955879"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: 'inherit', textDecoration: 'none' }}
                                >
                                    <FaFacebook size="30" />
                                </a>
                            </div>
                        </div>

                        {/* Privacy Policy Column */}
                        <div className="col-12 col-sm-6">
                            <div className="footer-widget my-4">
                                <a href="" onClick={() => navigate('/data-privacy')} style={{ color: 'white' }}>Data Privacy</a>
                            </div>
                        </div>


                    </div>
                </div>
            </footer>

            {/* Scroll Top Button */}
            <a href="#" className="scroll-top btn-hover">
                <i className="lni lni-chevron-up"></i>
            </a>
        </>
    );
};

export default LandingPage;